import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
      Developer API  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
         <h3 dir="rtl" className="container">
    
ה API שלנו כולל שני נתיבים<br/><br/>
הראשון הוא הכתובת של האתר המפנה עם סיומת של <div dir="ltr">/Credit-report </div><br/>
קריאה זו היא קריאת POST אותה אנו שולחים אחר כל הזנת פרטי כרטיס<br/>
הקריאה חוזרת אל האתר המפנה ומאפשרת לו לשמור את נתוני ההזמנה<br/>
אם האתר המפנה לא יטפל בקריאה זו, היא תכשל (אבל זה לא ישפיע על פעילות האתר ועל שמירת נתוני הכרטיס)<br/>
קריאה זו מאפשרת לאתר המפנה ליצור מאגר של נתוני ההזמנות על מנת שיוכל לקבל את פרטי הכרטיסים במערכת, ללא צורך בשמירת הנתונים המתקבלים באימייל<br/>
<br/>
הAPI  השני הוא נתיב לקבל נתוני האשראי <br/>
הנתיב הוא: https://dugoly.com/api/receive_credit<br/>
יש לבצע קריאה מסוג POST <br/>
יש לכלול באובייקט ה data  את הנתונים הבאים :<br/>
customer_ID ,  transaction_ID<br/>
ב קוקיס חייב להיות <br/>
Uid ו ה dugolyToken (הם מתקבלים אוטומטית ע"י dugoly login )<br/>
במקרה ואי אפשר לשלוח בכלל קוקיס ניתן לשלוח באובייקט ה data  גם את הערך "cookies", המכיל בתוכו את הנתונים הנ"ל,<br/>
במבנה:<br/>
<div dir="ltr">
cookies:`uid=…..;dugolyToken=……`<br/>
</div>
(שים לב, אם יתקבל איזשהו ערך ב קוקיס, המערכת לא תבדוק כלל את מציאת הנתוני ה קוקיס באובייקט של ה data , ערך זה מיועד רק כשאי אפשר לשלוח כלל קוקיס)<br/>
<br/>
דוגמה לאובייקט data  מלא:<br/>
<div dir="ltr">
<p style={{textAlign: 'left'}}>&nbsp;const data={'{'} <br />
customer_ID:this.state.customer_ID, <br />
transaction_ID:this.state.transaction_ID, <br />
cookies:`uid=${'{'}this.getCookie("uid"){'}'};<br />
dugolyToken=${'{'}this.getCookie("dugolyToken"){'}'}` <br />{'}'}&nbsp;&nbsp;</p>
</div>
<br/>
צורת שימוש האידיאלית בקריאת אלו היא:<br/>
הגדרת API  לקבל את הדיווח על קבלה חדשה לנתוני אשראי<br/>
וכשנדרשים הפרטים, לבצע קריאה לקבלת נתוני האשראי , לאחר שבוצע בו login with dugoly<br/>


</h3>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/Developer_API_he.js